<template>
  <div v-loading="loading">
    <el-table
      v-if="tableConfig"
      :key="tableKey"
      :data="representativeForms"
      style="width: 100%"
      row-key="id"
      @sort-change="handleSortChange"
    >
      <component
        :is="column.value"
        v-for="column in tableConfig.columns"
        :key="column.value"
      />
      <el-table-column
        fixed="right"
        label=""
        width="180"
        style="text-align: right;"
      >
        <template
          slot="header"
          slot-scope="scope"
        >
          <table-settings
            v-if="tableConfig"
            :config="tableConfig"
            :allcolumns="allColumns"
            :labels="labels"
            store-module="representativeForm"
            :options="['settings']"
          />
        </template>
        <template
          slot-scope="scope"
        >
          <Actions :representative-form="scope.row" />
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import Actions from './Actions';
  import TableSettings from '../../TableSettings';
  import columns, { allColumns, labels } from './columns';

  export default {
    components: {
      Actions,
      TableSettings,
      ...columns,
    },
    data() {
      return {
        labels,
        allColumns,
        tableKey: 0,
        currentPage: 1,
        currentSort: {
          prop: 'start_date',
          order: 'ascending',
        },
      };
    },
    computed: {
      representativeForms() {
        return this.$store.getters['representativeForm/representativeForms'];
      },
      tableConfig() {
        return JSON.parse(JSON.stringify(this.$store.getters['representativeForm/tableConfig']));
      },
      loading() {
        return this.$store.getters['representativeForm/loading'];
      },
    },
    watch: {
      tableConfig() {
        this.tableKey++;
      },
    },
    async mounted() {
      this.$store.commit('representativeForm/setFilterString', '');
      this.$store.commit('representativeForm/setCurrentPage', this.currentPage);
      this.$store.commit('representativeForm/setSorting', this.currentSort);
      await this.$store.dispatch('representativeForm/fetchAll');
    },
    methods: {
      handleCurrentChange(val) {
        this.$store.commit('representativeForm/setCurrentPage', val);
        this.$store.dispatch('representativeForm/fetchAll');
      },
      handleSortChange({ column, prop, order }) {
        if (column.sortable === 'custom') {
          this.$store.commit('representativeForm/setSorting', { prop, order });
          this.$store.dispatch('representativeForm/fetchAll');
        }
      },
    },
  };
</script>

